import { useParams } from 'react-router-dom';

import PrivateRoute, { Router } from '@Components/app-layout/PrivateRoute';

import PostBuilderFormLayout from './containers/BuilderForm';
import ContestsGridLayout from './containers/ContestsGrid';
import ContestsSubscriptions from './containers/ContestsSubscriptions';
import PostFormLayout from './containers/Form';
import PostGridLayout from './containers/Grid';
import SCAPromotionGridLayout from './containers/SCAPromotionGrid';
import TagsLayout from './views/tag/Layout';

export default function PostLayout() {
  const { content_type } = useParams()

  return <>
    <Router>
      <PrivateRoute exact
        path="/cms/:content_type"
        component={PostGridLayout}
      />
      <PrivateRoute path="/cms/:content_type/tags" component={TagsLayout} />
      <PrivateRoute exac path="/cms/:content_type/add" component={PostFormLayout} />
      {content_type === 'sweep' ? <PrivateRoute exact path="/cms/:content_type/contests" component={ContestsLayout} /> : null}
      {content_type === 'sweep' ? <PrivateRoute exact path="/cms/:content_type/:sweepId/contests" component={ContestsLayout} /> : null}
      {content_type === 'sweep' ? <PrivateRoute path="/cms/:content_type/:sweepId/contests/subscriptions" component={ContestsSubscriptions} /> : null}
      {content_type === 'sweep' ? <PrivateRoute path="/cms/:content_type/contests/subscriptions" component={ContestsSubscriptions} /> : null}
      {content_type === 'sweep' ? <PrivateRoute path="/cms/:content_type/sca" component={SCAPromotionGridLayout} /> : null}
      <PrivateRoute path="/cms/:content_type/:id/builder" component={PostBuilderFormLayout} />
      <PrivateRoute path="/cms/:content_type/:id" component={PostFormLayout} />
    </Router>
  </>
}

const ContestsLayout = () => <ContestsGridLayout />
